import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const MSPSidebar = ({ isVisible, toggleSidebar, mspConfig, tenantCount, userCount }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const compressed = !isVisible;

  return (
    <>
      {/* Toggle Button */}
      <div style={{ position: 'absolute', top: '60px', left: isVisible ? '230px' : '50px', zIndex: 1200 }}>
        <button
          onClick={toggleSidebar}
          style={{
            backgroundColor: '#342EAD',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            position: 'fixed',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          {isVisible ? <FaChevronLeft /> : <FaChevronRight />}
        </button>
      </div>

      {/* Sidebar */}
      <div 
        className="sidebar"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: compressed ? '70px' : '250px',
          height: '100%',
          backgroundColor: '#342EAD',
          color: '#ecf0f1',
          transition: 'width 0.3s ease',
          boxShadow: '2px 0 5px rgba(170, 172, 242, 0.33)',
          overflow: 'hidden',
          zIndex: 1000
        }}
      >
        {/* Logo */}
        <div className="d-flex align-items-center justify-content-center my-4" style={{ gap: compressed ? '0' : '12px' }}>
          <img src="/images/image4.png" alt="ODIR" style={{ width: '70px', height: '70px' }} />
          {!compressed && <span style={{ fontSize: '28px', fontWeight: 'bold' }}>ODIR</span>}
        </div>
        {!compressed && <div style={{ textAlign: 'center', fontSize: '14px', color: 'rgba(255,255,255,0.7)', marginTop: '-10px', marginBottom: '20px' }}>{mspConfig.name}</div>}

        <ul className="nav flex-column pt-4 p-2" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li className="nav-item">
            <Link to="/dashboard" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-tachometer-alt" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>Overview</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/tenants" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/tenants') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/tenants') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-building" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>Tenants ({tenantCount})</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/companies" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/companies') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/companies') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-sitemap" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>Companies</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/finops" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/finops') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/finops') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-dollar-sign" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>FinOps</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/security" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/security') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/security') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-shield-alt" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>SecureGuard</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/cloudmap" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/cloudmap') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/cloudmap') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-map" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>CloudMap</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/users" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/users') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/users') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-users" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>MSP Users ({userCount})</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/settings" className="nav-link" style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: isActive('/dashboard/settings') ? '#fff' : 'rgba(255,255,255,0.8)', backgroundColor: isActive('/dashboard/settings') ? 'rgba(255,255,255,0.1)' : 'transparent', textDecoration: 'none' }}>
              <i className="fas fa-cog" style={{ fontSize: '18px', minWidth: '20px' }}></i>
              {!compressed && <span style={{ marginLeft: '15px' }}>Settings</span>}
            </Link>
          </li>
        </ul>

        {!compressed && (
          <div style={{ position: 'absolute', bottom: '20px', width: '100%', textAlign: 'center', fontSize: '11px', color: 'rgba(255,255,255,0.5)' }}>
            Powered by ODIR
          </div>
        )}
      </div>
    </>
  );
};

export default MSPSidebar;
